import { query, repository, subscribe } from '@trlogic/client-js';
import CollectionNames from '../constant/CollectionNames';
import { InstanceContainer } from '../config/binding/InstanceBinding';
import Injectables from '../constant/Injectables';
import ComponentName from '../constant/ComponentName';
import { CheckerRequest } from '../domain/maker-checker/MakerCheckerDomains';
import eq = query.eq;
import and = query.and;

// Reactively tracks whether a given component+document already has a "Waiting" maker-checker
// request, so a UI can disable the action that would otherwise be rejected with
// PendingCheckerRequestException (e.g. a second delete request for the same list item).
class PendingCheckerRequestTracker {
  private readonly repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private subscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;

  public start(component: ComponentName, documentId: string, onChange: (pending: boolean) => void): void {
    if (!documentId) return;
    const pendingQuery = query.QueryBuilder.select()
      .from(CollectionNames.CHECKER_REQUESTS)
      .where(and(eq('component', component), eq('documentId', documentId), eq('status', 'Waiting')))
      .limit(1)
      .build();
    this.subscription = subscribe.Formica.subscribe(CollectionNames.CHECKER_REQUESTS, pendingQuery);
    this.computation = subscribe.Tracker.autorun(async () => {
      if (!this.subscription?.ready()) return;
      const found = await this.repository.find<CheckerRequest>(pendingQuery);
      onChange(found != undefined);
    }, [this.subscription]);
  }

  public async stop(): Promise<void> {
    await this.subscription?.stop();
    this.computation?.stop();
  }
}

export default PendingCheckerRequestTracker;
